import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useI18n } from "@/contexts/I18nContext";

export default function PublicFooter({ slug }) {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  const docLink = (type) => {
    if (slug) return `/p/${slug}/legal/${type}`;
    // Platform footer (Landing, etc.) — link to static platform legal pages
    const map = { legal_notice: "/legal/mentions", privacy: "/legal/confidentialite",
                  terms: "/legal/cgu", cookies_policy: "/legal/cookies" };
    return map[type] || "/legal/cgu";
  };
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-10 text-xs sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Logo className="h-5 w-5" />
          <span>© {year} Appel247 — {t("landing.footerRights")}</span>
        </div>
        <div className="flex flex-wrap gap-6 text-muted-foreground">
          {!slug && (
            <Link to="/pricing" className="hover:text-foreground" data-testid="footer-pricing-link">
              Tarifs
            </Link>
          )}
          <Link to={docLink("legal_notice")} className="hover:text-foreground" data-testid="footer-legal-link">
            Mentions légales
          </Link>
          <Link to={docLink("privacy")} className="hover:text-foreground" data-testid="footer-privacy-link">
            Confidentialité
          </Link>
          <Link to={docLink("terms")} className="hover:text-foreground" data-testid="footer-terms-link">
            CGU
          </Link>
          <Link to={docLink("cookies_policy")} className="hover:text-foreground" data-testid="footer-cookies-link">
            Cookies
          </Link>
        </div>
      </div>
    </footer>
  );
}
